import { render, staticRenderFns } from "./judicialSale.vue?vue&type=template&id=84563de6&scoped=true&"
import script from "./judicialSale.vue?vue&type=script&lang=js&"
export * from "./judicialSale.vue?vue&type=script&lang=js&"
import style0 from "./judicialSale.vue?vue&type=style&index=0&id=84563de6&prod&scoped=true&lang=css&"
import style1 from "./judicialSale.vue?vue&type=style&index=1&id=84563de6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84563de6",
  null
  
)

export default component.exports